const BaseView = require('./view');

module.exports = BaseView.extend({});
